'use client';

import { WebsiteEnv } from '@/constants/website-env';
import classes from './errorView.module.css';

const ErrorView = props => {
  const { message } = props;

  return (
    <div
      className={classes.root}
      data-cy='ErrorView-root'
    >
      <div className={classes.content}>
        <img
          className={classes.img}
          src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/404.png`}
          alt=''
        />
        <p className={classes.header}>Ohhh!Page Not Found</p>
        <p className={classes.message}>It seems we can&apos;t find what you&apos;re looking for.</p>
        <p className={classes.message}>Error Info: {message}</p>
        <p className={classes.goBack}>
          Go back to our <a href='/'>AW Bridal Home Page.</a>
        </p>
        <div className={classes.list}>
          <p className={classes.listTitle}>Explore AW Bridal Brand...</p>

          <ul className={classes.listContainer}>
            <li className={classes.listItem}>
              <div>
                <a href={`${process.env.NEXT_PUBLIC_BASE_PATH}/wedding-dresses`}>
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound1.jpg`}
                    alt='Wedding Dresses'
                  />
                  Wedding Dresses
                </a>
              </div>
            </li>
            <li className={classes.listItem}>
              <div>
                <a href={`${process.env.NEXT_PUBLIC_BASE_PATH}/bridesmaid-dresses`}>
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound2.jpg`}
                    alt='Bridesmaid Dresses'
                  />
                  Bridesmaid Dresses
                </a>
              </div>
            </li>
            <li className={classes.listItem}>
              <div>
                <a href={`${process.env.NEXT_PUBLIC_BASE_PATH}/mother-of-the-bride-dresses`}>
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound3.jpg`}
                    alt='Mother of the Bride Dresses'
                  />
                  Mother of the Brides
                </a>
              </div>
            </li>
            {WebsiteEnv.isUnitedStates ? (
              <li className={classes.listItem}>
                <div>
                  <a href={`${process.env.NEXT_PUBLIC_BASE_PATH}/wedding-accessories`}>
                    <img
                      src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound4.jpg`}
                      alt='Wedding Accessories'
                    />
                    Accessories
                  </a>
                </div>
              </li>
            ) : null}
            <li className={classes.listItem}>
              <div>
                <a
                  href={`${process.env.NEXT_PUBLIC_BASE_PATH}/${WebsiteEnv.isUnitedStates ? 'ready-to-ship' : 'wedding-guest-dresses'}`}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/wysiwyg/pagenotfound6.jpg`}
                    alt={WebsiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}
                  />
                  {WebsiteEnv.isUnitedStates ? 'Ready to Ship' : 'Wedding Guest Dresses'}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
